import { useEffect } from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import InmobiliariaSection from "../components/site/InmobiliariaSection";
import DespachoSection from "../components/site/DespachoSection";
import UbicacionSection from "../components/site/UbicacionSection";
import Footer from "../components/site/Footer";
import WhatsAppIcon from "../components/site/WhatsAppIcon";
import { INMOBILIARIA_WHATSAPP } from "../data/content";

const Landing = () => {
  useEffect(() => {
    document.title = "Inmobiliaria y Despacho Jurídico Rendón Ramos";
    if (window.location.hash) {
      const scrollToHash = (behavior) => {
        const el = document.querySelector(window.location.hash);
        if (el) el.scrollIntoView({ behavior, block: "start" });
      };
      setTimeout(() => scrollToHash("smooth"), 150);
      // Correcciones una vez que cargan imagenes y se estabiliza el layout
      setTimeout(() => scrollToHash("auto"), 900);
      setTimeout(() => scrollToHash("auto"), 1800);
    }
  }, []);

  return (
    <div>
      <Header />
      <main>
        <Hero />
        <InmobiliariaSection />
        <DespachoSection />
        <UbicacionSection />
      </main>
      <Footer />
      <a
        href={INMOBILIARIA_WHATSAPP.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-float"
        aria-label="Contactar por WhatsApp"
        data-testid="whatsapp-float"
      >
        <WhatsAppIcon size={28} />
      </a>
    </div>
  );
};

export default Landing;
